import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/esm/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React, { PureComponent } from 'react';
import raf from 'raf';
import hoistNonReactStatic from 'hoist-non-react-statics';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * Allows two animation frames to complete to allow other components to update
 * and re-render before mounting and rendering an expensive `WrappedComponent`.
 *
 * @param WrappedComponent
 * @param fallback
 */

function deferComponentRender(WrappedComponent, fallback) {
  var DeferredRenderWrapper = /*#__PURE__*/function (_PureComponent) {
    _inherits(DeferredRenderWrapper, _PureComponent);

    var _super = _createSuper(DeferredRenderWrapper);

    function DeferredRenderWrapper() {
      var _this;

      _classCallCheck(this, DeferredRenderWrapper);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this), "state", {
        shouldRender: false
      });

      return _this;
    }

    _createClass(DeferredRenderWrapper, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;

        raf(function () {
          return raf(function () {
            return _this2.setState({
              shouldRender: true
            });
          });
        });
      }
    }, {
      key: "render",
      value: function render() {
        // eslint-disable-next-line react/destructuring-assignment
        return this.state.shouldRender ? /*#__PURE__*/React.createElement(WrappedComponent, this.props) : fallback;
      }
    }]);

    return DeferredRenderWrapper;
  }(PureComponent);

  return hoistNonReactStatic(DeferredRenderWrapper, WrappedComponent);
}

export default deferComponentRender;
//# sourceMappingURL=index.js.map
